import { Route, Routes, } from 'react-router-dom';
import './App.css';
import { useState, useEffect } from 'react';
import details from"./dataStore/details.json"
import Home from './Pages/home';
import NavWeb from './components/navWeb';
import Footer from './components/footer';
import Tariff from './Pages/tariff';
import Contact from './Pages/contact';
import NavMob from './components/navMob';

function App() {
  // To Choose NavBar
//   false : <NavWeb/>
//   true : <NavMob/>
  const [navbar, setNavbar] = useState(false)
  const navSelect = () =>{
      if(window.innerWidth<768){
          setNavbar(true)
      }else{
          setNavbar(false)
      }
  }
  useEffect(() => {
      if (window.innerWidth<768){
          setNavbar(true)
      }else{
          setNavbar(false)
      }
          window.addEventListener('resize', navSelect);
          window.scrollTo(0, 0);
      return () => {
          window.scrollTo(0, 0);
          window.removeEventListener('resize', navSelect);
      };
  }, []);


// color in css
    document.documentElement.style.setProperty('--pri', details.primary_color);
    document.documentElement.style.setProperty('--sec', details.secondary_color);
  return (
    <>
    {navbar?<NavMob/>:<NavWeb/>}
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/tariff' element={<Tariff/>}/>
      <Route path='/contact' element={<Contact/>}/>
    </Routes>
    <Footer/>
    {navbar?<div className='notificationContainer'>
        <a href={`tel:+91${details.primary_phone}`} className='notificationIcon'>
            <img src='../images/callIcon.svg' alt='notif'/>
        </a>
    </div>:null}
    </>
  );
}

export default App;
